import { render } from "./FamilyHealthHistoryForm.vue?vue&type=template&id=25057baa&ts=true"
import script from "./FamilyHealthHistoryForm.ts?vue&type=script&lang=ts&external"
export * from "./FamilyHealthHistoryForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__